<template>
  <!-- name: '登录' -->
  <div class="loginWrap">
    <div class="buttonBox">
      <button v-if="!isWechat" class="quickBtnClass">快捷登录</button>
      <button
        v-if="!isWechat"
        class="codeBtnClass"
        @click="handleClick('账号密码')"
      >
        账号密码登录
      </button>
      <button
        class="phoneBtnClass"
        @click="$router.push({ path: '/phoneCodeLogin' })"
      >
        手机号验证码登录
      </button>
      <button
        v-if="!isWechat"
        class="registerBtnClass"
        @click="handleClick('注册')"
      >
        注册
      </button>
    </div>

    <div class="checkBox">
      <input
        type="checkBox"
        :checked="isChecked"
        @click="isChecked = !isChecked"
      />
      我已阅读并同意<span @click="showDialog = true">《需知协议》</span>
    </div>
    <van-dialog
      v-model="showDialog"
      title="操作提示"
      confirmButtonColor="#00a392"
    >
      <p>作为发布物品需求者，在信息发布之前我已经理解并同意以下说明条款：</p>
      <p>
        1）
        发布物品需求者所发布的需求信息均为真实、准确或者源于已知可靠的信息来源
      </p>
      <p>
        2）
        发布物品需求者如在发布需求之后得知任何关于信息不真实、不准确的情况，应于第一时间告知平台方并予以调整
      </p>
      <p>
        3）
        若发布物品需求者在已知的情况下提交和发布不真实的需求信息，平台方有权追究其法律责任。
      </p>
    </van-dialog>
    <van-dialog
      v-model="showCheck"
      title="操作提示"
      confirmButtonColor="#00a392"
      @confirm="handleConfirm"
    >
      <p>请勾选同意协议</p>
    </van-dialog>
  </div>
</template>

<script>
// import { removeToken } from "@/utils/localToken.js";
export default {
  components: {},
  data() {
    return {
      isChecked: false,
      showDialog: false,
      showCheck: false,
      isWechat: false,
    };
  },
  created() {
    // removeToken();
    if ("wx-mobile" === this.envjudge()) {
      this.isWechat = true;
    }
  },
  methods: {
    handleClick(type) {
      if (this.isChecked) {
        localStorage.setItem("type", type);
        this.$router.push({ path: "/formPage" });
      } else {
        this.showCheck = true;
      }
    },
    handleConfirm() {
      this.isChecked = !this.isChecked;
    },
    envjudge() {
      var isMobile =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(
          window.navigator.userAgent
        ); // 是否手机端
      var isWx = /micromessenger/i.test(navigator.userAgent); // 是否微信
      var isComWx = /wxwork/i.test(navigator.userAgent); // 是否企业微信

      if (isComWx && isMobile) {
        // 手机端企业微信
        return "com-wx-mobile";
      } else if (isComWx && !isMobile) {
        // PC端企业微信
        return "com-wx-pc";
      } else if (isWx && isMobile) {
        // 手机端微信
        return "wx-mobile";
      } else if (isWx && !isMobile) {
        // PC端微信
        return "wx-pc";
      } else {
        return "other";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.loginWrap {
  height: 100%;
  width: 100%;
  background-color: #b9cee5;
  background-image: url("https://img.bbalt.cn/imgh5/login_bg.png");
  background-size: 750px;
  background-repeat: no-repeat;
  text-align: center;
  overflow: hidden;
  display: flex;
  flex-flow: column;
  align-items: center;
  font-family: PingFang-SC, PingFang-SC;
  position: relative;
  .buttonBox {
    position: absolute;
    bottom: 8%;
    display: flex;
    flex-flow: column;
    button {
      margin-top: 24px;
      width: 640px;
      height: 94px;
      border-radius: 47px;
      border: none;

      font-size: 32px;

      font-weight: bold;
      color: #ffffff;
    }
    .quickBtnClass,
    .phoneBtnClass {
      background: #679fd2;
    }
    .codeBtnClass,
    .registerBtnClass {
      background: #fe74ae;
    }
  }
  .checkBox {
    position: absolute;
    bottom: 3%;
    margin-top: 32px;
    display: flex;
    justify-content: center;
    width: 100%;
    font-size: 24px;
    font-weight: 400;
    color: #999999;
    line-height: 32px;
    height: 32px;
    input[type="checkbox"] {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-image: url("https://img.bbalt.cn/imgh5/icon_unselect.png");
      background-size: 30px 30px;
      background-repeat: no-repeat;
      width: 30px !important;
      height: 30px !important;
      outline: none;
      box-sizing: border-box;
      padding: 0px;
      border-radius: 0px;
      border: none;
      background-color: #d8d8d8;
      margin-top: 0px;
      margin-right: 16px;
      margin-left: 8px;
    }
    input[type="checkbox"]:checked:checked {
      background: url("https://img.bbalt.cn/imgh5/icon_select.svg") no-repeat
        center;
      background-size: 100% 100%;
    }
  }
}
.van-dialog p {
  padding: 20px;
  line-height: 40px;
}
::v-deep .van-dialog__header {
  color: #000;
}
</style>
